export const getSamePathQueryNavigation = ({
	currentUrl,
	targetUrl,
}: {
	currentUrl: string;
	targetUrl: string;
}): string | undefined => {
	const current = new URL(currentUrl);
	const target = new URL(targetUrl, current);

	if (
		target.origin !== current.origin ||
		target.pathname !== current.pathname ||
		target.search === current.search
	) {
		return undefined;
	}

	return `${target.pathname}${target.search}${target.hash}`;
};
